import { differenceInDays, addDays } from "date-fns";


type Params = {
    from: Date,
    to: Date,
    daysFlexible?: number;
}

export default function getMiddleDate(params: Params): Date {
    let daysFlexible = params.daysFlexible || 0;
    const { to, from } = params;


    if (!daysFlexible) {
        const dateDiff = differenceInDays(to, from);
        return addDays(new Date(from), dateDiff / 2);
    }

    const middleDate = new Date(to);
    middleDate.setDate(middleDate.getDate() - daysFlexible);

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const availableSearchDate = new Date(today);
    availableSearchDate.setDate(availableSearchDate.getDate() + 1);

    return middleDate < availableSearchDate ? availableSearchDate : middleDate;

}